module.exports = __webpack_public_path__ + "img/trade.5e586468.png";